export default { 
    "type": 'warmup',
    "status": 'draft',
    "series": null,
    "working_title": "",
    "colour": 0,
    "file": "",
    "historical_name": "",
    "levels": [],
    "emotion": null,
    "intensity": null,
    "notes": "",
    "location": null,
    "timer_on_screen": null,
    "need_equipment": false,
    "spotify_playlist_name": "",
    "spotify_playlist_link": "",
    "apple_playlist_name": "",
    "apple_playlist_link": "",
    "required_music": true,
    "mode": null,
    "body_part": [],
    "benefit_1": null,
    "benefit_2": null,
    "benefit_3": null,
    "cautions": [],
    "naz_says": "",
    "naz_description": "",
    "need_chapterisation": false,
    "stretch_flow": null,
    "warm_up": null,
    "flag_intensity": 1,
    "flag_internal_notes": null,
    "render": null,
    "pre_production": null,
    "post_production": null,
    "warmup_chapterisation_short_description": null,
    "warmup_chapterisation_long_description": null,
}